import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useSubscription } from '../hooks/useSubscription';
import { Box, Typography, Paper, CircularProgress, Alert } from '@mui/material';
import { PLAN_TYPE } from '../constants/subscriptionTypes';

export default function Dashboard() {
  const { user, logout } = useAuth();
  const { subscription, loading, error } = useSubscription();

  // Helper function to format subscription type
  const formatSubscriptionType = (type) => {
    if (!type) return PLAN_TYPE.FREE;
    if (type === 'month' || type === PLAN_TYPE.MONTHLY) return 'Monthly';
    if (type === 'year' || type === PLAN_TYPE.YEARLY) return 'Annual';
    return type.charAt(0).toUpperCase() + type.slice(1);
  };

  return (
    <div style={{ padding: '20px' }}>
      <h1>Welcome, {user.displayName}</h1>
      <p>Email: {user.email}</p>
      <button
        onClick={logout}
        style={{
          marginTop: '20px',
          padding: '8px 16px',
          backgroundColor: '#f44336',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer'
        }}
      >
        Sign Out
      </button>
      
      <div style={{ marginTop: '40px' }}>
        <h2>Your Subscription</h2>
        
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
            <CircularProgress size={24} />
          </Box>
        ) : error ? (
          <Alert severity="error">{error}</Alert>
        ) : (
          <Paper elevation={2} sx={{ p: 2, mt: 2, maxWidth: 500 }}>
            <Typography variant="h6" gutterBottom>
              Plan: {formatSubscriptionType(subscription?.type)}
            </Typography>
            
            {subscription?.subscriptionDate && (
              <Typography variant="body1" gutterBottom>
                Started: {subscription.subscriptionDate}
              </Typography>
            )}
            
            {subscription?.nextPaymentDate && subscription.nextPaymentDate !== 'Invalid Date' && (
              <Typography variant="body1" gutterBottom>
                Next payment: {subscription.nextPaymentDate}
              </Typography>
            )}
            
            {(!subscription || subscription.type === PLAN_TYPE.FREE) && (
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                Upgrade to a paid plan for unlimited access to all features.
              </Typography>
            )}
          </Paper>
        )}
      </div>
    </div>
  );
}
